export type MeterLabelType = "percent" | "units";
export type MeterFillType = "single" | "range";
